// extracted by mini-css-extract-plugin
export default {"jana":"#f4e6d2","tumbleweed":"#dab177","link":"CA","wrapper":"CB"};